import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="min-h-screen flex flex-col items-center justify-center px-4" style={{ backgroundColor: 'var(--bg-color)', color: 'var(--text-color)' }}>
      <h1 className="mb-4" style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: 'italic', fontSize: 'clamp(4rem, 15vw, 12rem)', lineHeight: 1 }}>404</h1>
      <p className="mb-8" style={{ fontFamily: "'Archivo', sans-serif", fontSize: '0.75rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--muted-color)' }}>
        This page went out of style
      </p>
      <Link
        to="/"
        data-testid="back-home-link"
        className="px-6 py-3 text-xs uppercase tracking-widest font-semibold"
        style={{ backgroundColor: 'var(--accent-color)', color: '#fff', textDecoration: 'none', fontFamily: "'Archivo', sans-serif" }}
      >
        Back to the Issue
      </Link>
    </div>
  );
}
